import { render, staticRenderFns } from "./workSpaceList.vue?vue&type=template&id=f0f43600&scoped=true&lang=html&"
import script from "./workSpaceList.vue?vue&type=script&lang=js&"
export * from "./workSpaceList.vue?vue&type=script&lang=js&"
import style0 from "./workSpaceList.vue?vue&type=style&index=0&id=f0f43600&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f43600",
  null
  
)

component.options.__file = "workSpaceList.vue"
export default component.exports